import React from 'react';
import { Link } from 'react-router-dom';

export default function DashboardHeader({ title, subtitle, isIncoming, onOpenModal, onShowToast }) {
  return (
    <header className="cockpit-header">
      <div className="header-title-block">
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <h1 id="top-view-title" style={{ margin: 0 }}>{title || 'EXECUTIVE AGENTIC COCKPIT'}</h1>
          {isIncoming && <span className="header-badge-incoming">Incoming</span>}
        </div>
        <span id="top-view-sub">{subtitle || 'TECHMEDCOM — AI-POWERED DECISION CENTER'}</span>
      </div>

      <div className="header-quote-box">
        <i className="fa-solid fa-quote-left"></i>
        <div className="quote-text">
          “Hệ thống AI không thay thế con người. Hệ thống giải phóng năng lực để Ban Lãnh Đạo tập trung ra quyết định chiến lược.”
          <span className="quote-author">— Techmedcom AI Philosophy</span>
        </div>
      </div>

      <div className="header-user-actions">
        <Link to="/admin/jobs" className="btn-back-admin" title="Quay lại giao diện quản trị">
          <i className="fa-solid fa-arrow-left"></i> Về trang quản trị
        </Link>
        <button className="btn-ai-brain" onClick={() => onOpenModal('modal-brain')} type="button">
          <i className="fa-solid fa-brain" style={{ color: 'var(--gold)' }}></i> OpenClaw Brain
        </button>
        <div className="notification-btn" onClick={() => onOpenModal('modal-decisions')} role="button" tabIndex={0}>
          <i className="fa-regular fa-bell"></i>
          <span className="notification-badge">3</span>
        </div>
        <div
          className="user-avatar-btn"
          title="Ban Lãnh Đạo (Anh Thế / Chị Thảo)"
          onClick={() => onShowToast('Đang điều hành dưới quyền: Ban Lãnh Đạo (Anh Thế / Chị Thảo)')}
          role="button"
          tabIndex={0}
        >
          <div className="user-avatar-circle">BOD</div>
          <span className="user-avatar-name">Anh Thế / Chị Thảo</span>
        </div>
      </div>
    </header>
  );
}
